<div class="container-fluid pt-3 pb-3 d-flex flex-column flex-fill min-h-0 overflow-hidden">
  <div class="row g-3 mb-3 flex-shrink-0">
    <div class="col-lg-6">
      <div class="card h-100 position-relative">
        <button type="button" class="btn btn-outline-primary btn-sm position-absolute top-0 end-0 m-2"
          (click)="refresh()" [disabled]="loading"
          [attr.title]="'do_update' | translate">
          <i class="fas fa-sync-alt" [class.fa-spin]="loading"></i>
        </button>
        <div class="card-body d-flex align-items-center gap-3 py-2 px-3 h-100 pe-5">
          <img [src]="deviceImage()" [attr.alt]="'info' | translate" height="56" class="flex-shrink-0">
          <div class="min-w-0">
            <h6 class="fw-bold text-primary mb-0 text-truncate">{{  deviceInfo?.name ?? serial }}</h6>
            <small class="text-muted d-block">ID: {{ serial }}</small>
            <small class="text-muted d-block" *ngIf="updatedAt"> {{ 'updated' | translate }}: {{ formatDateTime(updatedAt) }}</small>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-6">
      <div class="card h-100 border-start border-4 d-flex align-items-center justify-content-center py-2"
        *ngIf="loading">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="visually-hidden">{{ 'loading' | translate }}</span>
        </div>
      </div>
      <div class="card h-100 border-start border-4"
        *ngIf="!loading"
        [ngClass]="isOutputOn ? 'bg-warning bg-opacity-10' : 'border-secondary'"
        [ngStyle]="isOutputOn ? {'border-left-color': '#e3e330', 'background-color': 'rgba(227, 227, 48, 0.1)'} : null">
        <div class="card-body d-flex flex-wrap align-items-center gap-3 py-2 px-3 h-100">
          <i class="fas fa-lightbulb fa-3x flex-shrink-0"
            [class.text-warning-2]="relayStat?.state === 'on'"
            [class.text-secondary]="relayStat?.state === 'off'"></i>
          <div class="min-w-0">
            <small class="text-muted d-inline-flex align-items-center gap-1 mb-0">
              {{ 'output1' | translate }}
              <i class="fa-solid fa-lock text-warning" *ngIf="relayStat?.permanent === 1"></i>
              <i class="fa-solid fa-unlock text-muted" *ngIf="relayStat?.permanent === 0"></i>
            </small>
            <div class="fw-bold mb-0 text-capitalize"
              [class.text-warning-2]="relayStat?.state === 'on'"
              [class.text-secondary]="relayStat?.state === 'off'">
              <ng-container *ngIf="relayStat?.state === 'on'">{{ 'on' | translate }}</ng-container>
              <ng-container *ngIf="relayStat?.state === 'off'">{{ 'off' | translate }}</ng-container>
              <ng-container *ngIf="relayStat?.state === null">--</ng-container>
            </div>
          </div>
          <div class="d-flex flex-column gap-1 small text-muted ms-lg-auto ps-lg-3 border-lg-start">
            <span><i class="far fa-clock me-1" aria-hidden="true"></i>{{ 'totalHours' | translate }} {{ relayStat?.total_minutes/60 | number:'1.2-2' }} h</span>
            <span><i class="far fa-hourglass-half me-1" aria-hidden="true"></i>{{ 'partialHours' | translate }} {{ relayStat?.partial_minutes/60 | number:'1.2-2' }} h</span>
            <span><i class="fas fa-bolt me-1" aria-hidden="true"></i>{{ 'energy' | translate }} {{ relayStat?.e | number:'1.2-2' }} kWh</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3 flex-shrink-0">
    <h6 class="fw-bold text-primary mb-0">{{ 'ActivityClock' | translate }}</h6>
    <div class="dropup z-3">
      <button type="button" class="btn btn-sm btn-outline-primary dropdown-toggle text-nowrap"
        data-bs-toggle="dropdown"
        [disabled]="loading || !filteredSessions().length">
        <i class="fas fa-download me-1"></i>{{ 'export' | translate }}
      </button>
      <ul class="dropdown-menu dropdown-menu-end">
        <li><button type="button" class="dropdown-item" (click)="download('csv')">CSV</button></li>
        <li><button type="button" class="dropdown-item" (click)="download('xlsx')">XLSX</button></li>
      </ul>
    </div>
  </div>

  <div class="card flex-grow-1 d-flex flex-column min-h-0 mb-0 overflow-hidden">
    <div class="card-body p-0 d-flex flex-column flex-grow-1 min-h-0">
      <div *ngIf="loading" class="flex-grow-1 d-flex align-items-center justify-content-center">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'loading' | translate }}</span>
        </div>
      </div>

      <div class="flex-grow-1 min-h-0 overflow-auto" *ngIf="!loading">
        <div *ngIf="filteredSessions().length === 0" class="text-center text-muted py-4">
          {{ 'ancHistoricsPlaceholder' | translate }}
        </div>

        <ng-container *ngIf="filteredSessions().length > 0">
          <div class="d-none d-lg-flex border-bottom bg-light small fw-semibold text-muted sticky-top">
            <div class="col-lg-7 px-3 py-2">{{ 'on' | translate }} / {{ 'off' | translate }}</div>
            <div class="col-lg-5 px-3 py-2">{{ 'historicsDuration' | translate }} · {{ 'historicsEnergy' | translate }}</div>
          </div>

          <div *ngFor="let session of pagedSessions()" class="row g-0 align-items-stretch">
            <div class="col-lg-7 d-flex flex-column">
              <div *ngFor="let record of session.records" class="data-item data-item--sm d-flex flex-wrap align-items-center gap-2 px-3 py-1">
                <div class="data-icon"
                  [class.bg-secondary]="record.state === 'off'"
                  [class.bg-opacity-10]="record.state === 'off'"
                  [style.background-color]="record.state === 'on' ? 'rgba(247, 210, 26, 0.15)' : null">
                  <i class="fas fa-lightbulb" [class.text-warning-2]="record.state === 'on'" [class.text-secondary]="record.state === 'off'"></i>
                </div>
                <div class="data-content min-w-0">
                  <div class="data-value text-uppercase" [class.text-secondary]="record.state === 'off'">
                    {{ (record.state === 'on' ? 'on' : 'off') | translate }}
                  </div>
                  <small class="data-label">{{ formatDateTime(record.at) }}</small>
                </div>
                <div class="ms-auto fw-semibold small" [attr.title]="'totalHours' | translate">
                  <i class="far fa-clock text-muted me-1" aria-hidden="true"></i>{{ formatDuration(record.minutes * 60) }}
                </div>
                <div class="fw-semibold small text-primary" [attr.title]="'energy' | translate">
                  <i class="fas fa-bolt text-muted me-1" aria-hidden="true"></i>{{ record.energyKwh | number:'1.2-2' }} kWh
                </div>
              </div>
            </div>

            <div *ngIf="isClosed(session)" class="col-lg-5 d-flex flex-column flex-lg-row align-items-lg-center bg-white px-3 py-1 gap-2 gap-lg-3">
              <span class="interval-rule flex-shrink-0" aria-hidden="true"></span>
              <div class="d-flex flex-column flex-sm-row gap-2 w-100">
                <div class="data-item data-item--sm d-flex align-items-center gap-2 flex-fill">
                  <div class="data-icon bg-primary bg-opacity-10">
                    <i class="far fa-clock text-primary"></i>
                  </div>
                  <div class="data-content">
                    <div class="data-value">{{ formatDuration(session.durationSeconds) }}</div>
                    <small class="data-label">{{ 'historicsDuration' | translate }}</small>
                  </div>
                </div>
                <div class="data-item data-item--sm d-flex align-items-center gap-2 flex-fill">
                  <div class="data-icon bg-primary bg-opacity-10">
                    <i class="fas fa-bolt text-primary"></i>
                  </div>
                  <div class="data-content">
                    <div class="data-value">{{ session.energyKwh | number:'1.2-2' }} kWh</div>
                    <small class="data-label">{{ 'partialEnergy' | translate }}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="flex-shrink-0 d-flex flex-wrap justify-content-between align-items-center gap-2 px-3 py-2 border-top small text-muted bg-white"
        *ngIf="!loading && filteredSessions().length > 0">
        <span *ngIf="pageSummary() as page">{{ 'showingRecordsOf' | translate:{ from: page.from, to: page.to, total: page.total } }}</span>
        <nav *ngIf="totalPages() > 1" [attr.aria-label]="'ActivityClock' | translate">
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="currentPage === 1">
              <button type="button" class="page-link" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">
                {{ 'previous' | translate }}
              </button>
            </li>
            <li class="page-item disabled">
              <span class="page-link">{{ currentPage }} / {{ totalPages() }}</span>
            </li>
            <li class="page-item" [class.disabled]="currentPage === totalPages()">
              <button type="button" class="page-link" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages()">
                {{ 'following' | translate }}
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>
